module.exports = __webpack_public_path__ + "20f82bc812549b7818b86ea646279bba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1570559747074
// module id = 15
// module chunks = 0